import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getTournaments,
  getTournamentList,
  getTournamentById,
  createTournament,
  updateTournament,
  deleteTournament,
} from "../../api/admin/tournaments.api";

/* =============================================================
   FETCH TOURNAMENTS DROPDOWN
============================================================= */

export const fetchTournaments = createAsyncThunk(
  "admin/tournaments/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getTournaments();

      if (!res?.success) {
        return rejectWithValue(
          res?.message || "Failed to fetch tournaments"
        );
      }

      return Array.isArray(res.data) ? res.data : [];
    } catch (error) {
      return rejectWithValue(
        error?.message || "Unexpected error occurred"
      );
    }
  }
);

// export const fetchTournaments = createAsyncThunk(
//   "admin/tournaments/fetch",
//   async (_, { rejectWithValue }) => {
//     try {
//       const res = await getTournaments();

//       if (!res?.success) {
//         return rejectWithValue(res?.message || "Failed to fetch tournaments");
//       }

//       return Array.isArray(res.data) ? res.data : [];
//     } catch (error) {
//       return rejectWithValue(error?.message || "Unexpected error occurred");
//     }
//   },
//   {
//     condition: (_, { getState }) => {
//       try {
//         const state = getState();
//         const { lastFetched } = state.admin?.tournaments || {};
//         const FIVE_MINUTES = 5 * 60 * 1000;
//         if (lastFetched && Date.now() - lastFetched < FIVE_MINUTES) {
//           return false;
//         }
//         return true;
//       } catch {
//         return true;
//       }
//     },
//   }
// );

/* =============================================================
   FETCH TOURNAMENT MASTER LIST
============================================================= */
export const fetchTournamentList = createAsyncThunk(
  "admin/tournaments/fetchList",
  async (
    {
      page = 1,
      limit = 10,
      search = "",
      category_id = "",   // ← added
    } = {},
    { rejectWithValue }
  ) => {
    try {
      const res = await getTournamentList({
        page,
        limit,
        search,
        category_id,       // ← forwarded to API
      });

      if (!res.success) {
        return rejectWithValue(res.message || "Failed to fetch tournaments");
      }

      return res;
    } catch (error) {
      return rejectWithValue(error.message || "Unexpected error occurred");
    }
  }
);

/* =============================================================
   FETCH SINGLE TOURNAMENT
============================================================= */
export const fetchTournamentById = createAsyncThunk(
  "admin/tournaments/fetchById",
  async (id, { rejectWithValue }) => {
    try {
      const res = await getTournamentById(id);

      if (!res.success) {
        return rejectWithValue(res.message || "Failed to fetch tournament");
      }

      return res.data;
    } catch (error) {
      return rejectWithValue(error.message || "Unexpected error occurred");
    }
  }
);

/* =============================================================
   CREATE TOURNAMENT
============================================================= */
export const addTournament = createAsyncThunk(
  "admin/tournaments/create",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await createTournament(payload);

      if (!res.success) {
        return rejectWithValue(res.message || "Failed to create tournament");
      }

      return res;
    } catch (error) {
      return rejectWithValue(error.message || "Unexpected error occurred");
    }
  }
);

/* =============================================================
   UPDATE TOURNAMENT
============================================================= */
export const editTournament = createAsyncThunk(
  "admin/tournaments/update",
  async ({ id, tournamentData }, { rejectWithValue }) => {
    try {
      const res = await updateTournament(id, tournamentData);

      if (!res.success) {
        return rejectWithValue(res.message || "Failed to update tournament");
      }

      return { id, ...tournamentData };
    } catch (error) {
      return rejectWithValue(error.message || "Unexpected error occurred");
    }
  }
);

/* =============================================================
   DELETE TOURNAMENT
============================================================= */
export const removeTournament = createAsyncThunk(
  "admin/tournaments/delete",
  async (id, { rejectWithValue }) => {
    try {
      const res = await deleteTournament(id);

      if (!res.success) {
        return rejectWithValue(res.message || "Failed to delete tournament");
      }

      return { id, message: res.message };
    } catch (error) {
      return rejectWithValue(error.message || "Unexpected error occurred");
    }
  }
);